import type {
  OAuthRedirectSerializer,
  OAuthScopeSerializer,
  OAuthScopesSerializer,
  OAuthAppSerializer,
  OAuthAllowScopesQuery,
  IApiResponse,
} from "@litres-libs/types";
import type { IOauthAuthorizeParams, IOauthClientsParams } from "./types";
import { rtkqApi } from "../api/rtkqApi";

export const oauthApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    authorize: build.mutation<string, IOauthAuthorizeParams>({
      query: params => ({
        url: "/foundation/api/oauth/authorize",
        params,
      }),
      transformResponse: (response: IApiResponse<OAuthRedirectSerializer>) =>
        response.payload.data.redirect_uri,
    }),
    oauthScopes: build.query<OAuthScopeSerializer[], void>({
      query: () => ({
        url: "/foundation/api/oauth/scopes",
        method: "GET",
      }),
      transformResponse: (response: IApiResponse<OAuthScopesSerializer>) =>
        response.payload.data.scopes,
    }),
    getClients: build.query<string, IOauthClientsParams>({
      query: params => ({
        url: `/foundation/api/oauth/clients/${params.client_id}`,
        method: "GET",
      }),

      transformResponse: (response: IApiResponse<OAuthAppSerializer>) =>
        response.payload.data.title,
    }),
    allowScopes: build.mutation<string, OAuthAllowScopesQuery>({
      query: params => ({
        url: "/foundation/api/oauth/allow-scopes",
        method: "POST",
        body: params,
      }),
      transformResponse: (response: IApiResponse<OAuthRedirectSerializer>) => {
        return response.payload.data.redirect_uri;
      },
    }),
  }),
});
